// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{display:block;padding-left:15px}fa-icon{cursor:pointer;font-size:10px;margin-left:5px}.plus-icon{color:#ff5a00;font-size:12px;margin-right:7px}.show-more{display:inline-flex;align-items:center;color:#ff5a00;cursor:pointer;margin-left:15px;text-decoration:underline;height:28px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
